const validateEmail = (input) => {
  if (!input || input.toString().trim() === "") {
    return true;
  }

  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return regex.test(String(input).toLowerCase());
};
const validateRequired = (input) => {
  if (input === "" || input == null || input == 0) {
    return false;
  }
  return true;
};

const validateMaxLength = (input, length) => {
  if (input.length > length) {
    return false;
  }
  return true;
};
const validateMinLength = (input, length) => {
  return input.length < length;
};

const validateLength = (input, length) => {
  if (input.length !== length) {
    return false;
  }
  return true;
};
const validateFile = (input, accepted = ["image/png"], size = 5248000) => {
  accepted = ["image/png", "application/pdf", "image/jpg", "image/jpeg"];
  var format = /[!@#$%^&*()+\-=[\]{};':"\\|,<>/?]+/;
  if (
    input.name.match(/\./g).length > 1 ||
    format.test(input.name) ||
    !accepted.includes(input.type) ||
    input.size > size
  ) {
    return false;
  }
  return true;
};
const validateFileSize = (file, maxMb = 5) => {
  return (file?.size || 0) <= maxMb * 1024 * 1024;
};
const validateFileType = (file, allowedTypes = []) => {
  const defaultTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/jfif",
    "application/pdf",
  ];
  const accepted = allowedTypes.length > 0 ? allowedTypes : defaultTypes;
  return accepted.includes(file.type.toLowerCase());
};
const validateFileNameSpecialChar = (input) => {
  var format = /^(?!.*[!@#$%^&*+=\[\]{};\\'":|,<>\/?\`])(?!.*\..*\.).+$/;
  return format.test(input.name);
};
const validateFileSizeDispute = (input, size = 5248000) => {
  // var format = /[!@#$%^&*()+\-=[\]{};':"\\|,<>/?]+/;
  if (
    // input.name.match(/\./g).length > 1 ||
    // format.test(input.name) ||
    input.size > size
  ) {
    return false;
  }
  return true;
};

const validateFileTypeDispute = async (
  input,
  accepted = [
    "image/png",
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/jfif",
  ],
) => {
  // if (!input || !input.name || !input.type) {
  //   return false; // Invalid input
  // }

  // // Check for invalid file name characters
  // const invalidChars = /[<>:"/\\|?*]+/; // Invalid characters for file names
  // if (invalidChars.test(input.name)) {
  //   return false;
  // }

  // Check for multiple dots (e.g., "my..file.pdf")
  // if ((input.name.match(/\./g) || []).length > 1) {
  //   return false;
  // }

  // Check if the file type is in the accepted list
  if (!accepted.includes(input.type)) {
    return false;
  }
  // return true;
  const validTypes = {
    jpeg: "FFD8FF",
    png: "89504E47",
    pdf: "25504446",
    jpg: "FFD8FF",
    jfif: "FFD8FF",
  };
  // Read first 4 bytes of the file
  const buffer = await input.slice(0, 4).arrayBuffer();
  const bytes = new Uint8Array(buffer);

  // Convert to hexadecimal
  const hex = Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase();

  // Check against known signatures
  const isValid = Object.values(validTypes).some((signature) =>
    hex.startsWith(signature),
  );
  return isValid;
};

const validatePassword = (password) => {
  // 1. Mandatory: 1 Lowercase, 1 Uppercase, 1 Number
  // 2. Allowed: English letters, Numbers, and specific special chars
  const re =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\-\_\!\@\#\$\%\^\&\*\+\=\[\]\{\}\;\:\'\"\|\,\<\>\/\?\`]+$/;
  return re.test(password);
};

const validateDateIsDateInFuture = (date) => {
  return new Date(date) >= Date.now();
};

const validateٍStartDateIsGreaterThanEnd = (startDate, endDate) => {
  var startTime = new Date(startDate);
  var endTime = new Date(endDate);

  return startTime > endTime;
};

const validateSpicalCharacters = (string) => {
  var format = /[!@#؟$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

  if (format.test(string) && !validateManySpace(string)) {
    return true;
  } else {
    return false;
  }
};

const validateDigitCharacters = (myString) => {
  return /\d/.test(myString);
};

const validateManySpace = (string) => {
  return /[ ]{2,}/.test(string);
};
/* const validateNoOrOneSpace = (string) => {
  return string.match(/\s/g)?.length > 1;
}; */
const validateNoWhitespace = (str) => !/\s/.test(str);
// const hasOnlySingleSpaces = (str) => {
//   return !/^\s|\s{2,}|\s$/.test(str);
// };
const hasOnlySingleSpaces = (str) => {
  if (!str.trim().includes(" ")) return false;
  const hasSingleSpaceGap = /(?<=\S)\s(?=\S)/.test(str);

  return !hasSingleSpaceGap;
};
const validateNotDigitSpicalCharacters = (string) => {
  if (
    validateSpicalCharacters(string) ||
    validateDigitCharacters(string) ||
    validateManySpace(string)
  ) {
    return false;
  } else {
    return true;
  }
};

const validateFloorsSeries = (floors, floor_number, date_key, date_value) => {
  const floors_data = Object.assign([], floors);
  floors_data.sort(function (a, b) {
    return a.floor_number - b.floor_number;
  });

  for (const element of floors_data) {
    if (parseInt(element.floor_number) === parseInt(floor_number)) {
      return true;
    }
    if (validateٍStartDateIsGreaterThanEnd(element[date_key], date_value)) {
      return false;
    }
  }
};

const validateIsArabicString = (string) => {
  return !/[^\u0600-\u06FF\u0020-\u0040\u005B-\u0060\u007B-\u007E]/.test(
    string,
  );
};

const validateRealNumbers = (string) => {
  var format = /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/;

  if (
    format.test(string) &&
    parseFloat(string) >= 1 &&
    decimalCount(string) <= 2
  ) {
    return true;
  } else {
    return false;
  }
};
const validatePostiveInteger = (myString) => {
  return /^[1-9]\d*$/.test(myString);
};

const validatePostiveFloat = (myString) => {
  return /^(\d+.?\d{0,2})$/.test(myString);
};
const validateTotalAreaWithBuildings = (total_area, buildings, key) => {
  let sum = 0;
  buildings.forEach((element, index) => {
    sum += parseInt(element[key]);
  });
  if (parseFloat(sum) > parseFloat(total_area)) {
    return false;
  }
  return true;
};
const validateSpicalCharactersExceptSlash = (string) => {
  var format = /[ `!@#$؟%^&*()_+\-=[\]{};':"|,.<>?~]/;
  if (format.test(string)) {
    return true;
  } else {
    return false;
  }
};
const decimalCount = (num) => {
  // Convert to String
  const numStr = String(num);
  // String Contains Decimal
  if (numStr.includes(".")) {
    return numStr.split(".")[1].length;
  }
  // String Does Not Contain Decimal
  return 0;
};
const validateIfFloorExistBefore = (floors_data, index, key, value) => {
  for (let i = 0; i < floors_data.length; i++) {
    if (parseInt(floors_data[i][key]) === parseInt(value) && i !== index) {
      return false;
    }
  }
  return true;
};
const validateSumFloorArea = (floors_data, index, key, value) => {
  let sum = 0;
  for (let i = 0; i < floors_data.length; i++) {
    sum += parseInt(floors_data[i].floor_area);
  }
  return sum;
};

const validateStartDateIsGreaterThanEnd = (startDate, endDate) => {
  var startTime = new Date(startDate);
  var endTime = new Date(endDate);

  return startTime > endTime;
};

const validateNationalID = (value) => {
  if (value === "" || value === null) return true;
  var regex = /[^0-9]/;
  if (regex.test(value)) {
    return false;
  }

  if (value?.length !== 14) return false;

  var century_key = parseInt(value.substr(0, 1));

  var yearString = value.substr(1, 2);

  var full_year = century_key === 2 ? "19" + yearString : "20" + yearString;

  var monthString = value.substr(3, 2);

  var dayString = value.substr(5, 2);

  const full_date = full_year + "/" + monthString + "/" + dayString;
  if (!/^\d{4}\/\d{1,2}\/\d{1,2}$/.test(full_date)) {
    return false;
  }

  // Parse the date parts to integers
  var parts = full_date.split("/");
  var day = parseInt(parts[2], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[0], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29;

  // check if greater than 18 years
  var startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 18);
  if (!validateStartDateIsGreaterThanEnd(startDate, full_date)) {
    return false;
  }

  // check city id
  const city_id = value.substr(7, 2);
  const cities_codes = [
    "01",
    "02",
    "03",
    "04",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "31",
    "32",
    "33",
    "34",
    "35",
    "88",
  ];
  if (!cities_codes.includes(city_id)) return false;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
};

const validateNationalIDWithoutAgeLimit = (value) => {
  if (value === "" || value === null) return true;
  var regex = /[^0-9]/;
  if (regex.test(value)) {
    return false;
  }

  if (value?.length !== 14) return false;

  const firstChar = value.charAt(0);
  if (firstChar !== "2" && firstChar !== "3") {
    return false;
  }

  var century_key = parseInt(value.substr(0, 1));

  var yearString = value.substr(1, 2);

  var full_year = century_key === 2 ? "19" + yearString : "20" + yearString;

  var monthString = value.substr(3, 2);

  var dayString = value.substr(5, 2);

  const full_date = full_year + "/" + monthString + "/" + dayString;
  if (!/^\d{4}\/\d{1,2}\/\d{1,2}$/.test(full_date)) {
    return false;
  }

  // Parse the date parts to integers
  var parts = full_date.split("/");
  var day = parseInt(parts[2], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[0], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29;

  // check if greater than 18 years
  // var startDate = new Date();
  // startDate.setFullYear(startDate.getFullYear() - 18);
  // if (!validateStartDateIsGreaterThanEnd(startDate, full_date)) {
  //   return false;
  // }

  // check city id
  const city_id = value.substr(7, 2);
  const cities_codes = [
    "01",
    "02",
    "03",
    "04",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "31",
    "32",
    "33",
    "34",
    "35",
    "88",
  ];
  if (!cities_codes.includes(city_id)) return false;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
};

const validateOnlyArabicOrEnglishNoSpaces = (value) => {
  const regex = /^(?!.*؟)(?:[A-Za-z]+|[\u0600-\u06FF]+)$/;
  return regex.test(value);
};
const validateOnlyArabicOrEnglishOneSpaceBetweenWords = (value) => {
  const regex = /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/;
  return regex.test(value);
};
const validateAlphaNumericWithSymbols = (value) => {
  const regex = /^[A-Za-z0-9/-]+$/;
  return regex.test(value);
};

const validateEgyptianPhoneNumber = (value) => {
  const regex = /^0(10|11|12|15)\d{8}$/;
  return regex.test(value);
};

const validateEgyptianPhoneNumberWithPhoneInput = (value) => {
  // ✅ Remove non-digit characters (like +, spaces, dashes)
  let normalized = value.replace(/\D/g, "");

  if (normalized.startsWith("200")) {
    normalized = "20" + normalized.slice(3);
  }

  // ✅ Regex for Egyptian mobile numbers
  const regex = /^20(10|11|12|15)\d{8}$/;

  return regex.test(normalized);
};

const validateAllowedCharForEmail = (value) => {
  const regex = /^[A-Za-z0-9\.\_\@\-]+$/;
  return regex.test(value);
};
export {
  validateEmail,
  validateRequired,
  validateMaxLength,
  validateMinLength,
  validateLength,
  validateFile,
  validatePassword,
  validateDateIsDateInFuture,
  validateٍStartDateIsGreaterThanEnd,
  validateSpicalCharacters,
  validateDigitCharacters,
  validateNotDigitSpicalCharacters,
  validateFloorsSeries,
  validateManySpace,
  /* validateNoOrOneSpace, */
  validateIsArabicString,
  validateRealNumbers,
  validatePostiveInteger,
  validatePostiveFloat,
  validateTotalAreaWithBuildings,
  validateSpicalCharactersExceptSlash,
  validateIfFloorExistBefore,
  validateSumFloorArea,
  validateFileType,
  validateFileTypeDispute,
  validateFileSizeDispute,
  validateFileSize,
  validateFileNameSpecialChar,
  validateNationalID,
  validateNationalIDWithoutAgeLimit,
  hasOnlySingleSpaces,
  validateNoWhitespace,
  validateAlphaNumericWithSymbols,
  validateEgyptianPhoneNumber,
  validateOnlyArabicOrEnglishNoSpaces,
  validateOnlyArabicOrEnglishOneSpaceBetweenWords,
  validateAllowedCharForEmail,
  validateEgyptianPhoneNumberWithPhoneInput,
};
